import type { Translate } from 'common/providers/LocaleProvider';
import type { TrackableArticle } from './articleToTrackingProps';
import { articleToTrackingProps } from './articleToTrackingProps';

export const transformArticleTrackingData = <T extends TrackableArticle>(
  props: T,
  t?: Translate
) => {
  const tracking = articleToTrackingProps(props);

  if (props.sponsored?.owner && t) {
    tracking.productLabels = [...(tracking.productLabels ?? []), t('h24_product_card_sponsored')];
  }

  return {
    ...props,
    tracking,
  };
};
